import React from 'react'
import { getExtension } from '../../../helpers/helpers'
import { clearAll, showAttachmentFunc } from '../../../config/redux/slice/appSlice';
import { useDispatch } from 'react-redux';
import { image_extensions } from '../../../constants/english';

export default function AttachmentView({filePath}) {
    const dispatch = useDispatch()
    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showAttachmentFunc({ modal: false }));
    };
  return (
    <div 
    onClick={closeModal}
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div className="modal-content">
      {image_extensions.includes((getExtension(filePath)).toLowerCase()) ? 
        <img className='attachment-img' src={filePath} alt='letter file attachment'/> :
        <iframe className='attachment-pdf' src={filePath} title='Certificate PDF'></iframe>
        }
    </div>
  </div>
</div>
  )
}
